var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhyNurse3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0H64C72.8366 0 80 7.16344 80 16V64C80 72.8366 72.8366 80 64 80H16C7.16344 80 0 72.8366 0 64V16Z",
    fill: "#EAF1FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3072_3438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5222 52.6825H17.8418C17.0652 52.6825 16.4355 53.3121 16.4355 54.0887V62.5937C16.4355 63.3704 17.0652 64 17.8418 64H28.9286V54.0887C28.9285 53.3121 28.299 52.6825 27.5222 52.6825Z",
    fill: "#4F8AFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4227 44.8075H33.1484C32.3718 44.8075 31.7422 45.4371 31.7422 46.2137V64H42.829V46.2137C42.829 45.4371 42.1993 44.8075 41.4227 44.8075Z",
    fill: "#4F8AFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7933 23.5947L63.6274 20.5188C64.0062 20.1081 64.1055 19.5128 63.8815 19.0019C63.6574 18.49 63.1521 18.16 62.5933 18.16H53.5278V17.4062C53.5278 16.63 52.8987 16 52.1216 16C51.3453 16 50.7153 16.63 50.7153 17.4062V33.8125H47.0469C46.2702 33.8125 45.6406 34.4421 45.6406 35.2188V64H56.9665C57.7437 64 58.3727 63.37 58.3727 62.5938V35.2188C58.3727 34.4425 57.7437 33.8125 56.9665 33.8125H53.5278V28.7809H62.5933C63.1624 28.7809 63.6752 28.4378 63.8927 27.9119C64.1102 27.3859 63.9893 26.7803 63.5862 26.3791L60.7933 23.5947Z",
    fill: "#4F8AFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8644 28.0736C40.2095 28.7694 41.0531 29.0537 41.749 28.7087C42.4448 28.3636 42.7291 27.5198 42.384 26.824C39.8346 21.683 40.0925 22.2013 40.0555 22.1314C39.7912 21.6321 39.2474 21.3306 38.6684 21.3906C38.6644 21.391 38.6604 21.3918 38.6564 21.3923C38.5413 21.4052 38.8485 21.345 33.5222 22.4658C32.7622 22.6258 32.2758 23.3716 32.4357 24.1316C32.5751 24.7939 33.1594 25.2485 33.8103 25.2485C34.0061 25.2485 33.88 25.2647 36.3532 24.7442C34.5091 28.3639 32.109 31.6626 29.1944 34.5774C25.6223 38.1497 21.472 40.9502 16.8588 42.9014C16.1435 43.204 15.8089 44.029 16.1114 44.7443C16.4142 45.4603 17.2396 45.794 17.9544 45.4918C22.9028 43.3988 27.3536 40.3958 31.1831 36.5661C34.3043 33.4449 36.876 29.9119 38.853 26.0344L39.8644 28.0736Z",
    fill: "#4F8AFB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3072_3438"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyNurse3);
export default __webpack_public_path__ + "static/media/whyNurse3.68962220c71d5d891f4786f4ae60c294.svg";
export { ForwardRef as ReactComponent };